import { Grid } from '@mui/material';
import React, { MouseEventHandler } from 'react';
import { AppDivider, Button } from '..';
import './BoxSearch.scss';

interface BoxSearchProps {
  onSearch?: MouseEventHandler<HTMLButtonElement>;
  onClear?: MouseEventHandler<HTMLButtonElement>;
  children?: React.ReactNode;
  isDivider?: boolean;
}

const AppBoxSearch: React.FC<BoxSearchProps> = ({
  onSearch,
  onClear,
  children,
  isDivider = false,
}) => {
  return (
    <div className='BoxSearch'>
      <div className='BoxSearch__wrapper'>
        <Grid container flex={1} spacing={1}>
          {children}
        </Grid>
        <div className='BoxSearch__groupbtn'>
          {onSearch && (
            <Button
              onClick={onSearch}
              title='common.search'
              typeName='primary'
            />
          )}
          {onClear && (
            <Button
              color='secondary'
              onClick={onClear}
              title='common.clear'
              typeName='secondary'
            />
          )}
        </div>
      </div>
      {isDivider && <AppDivider />}
    </div>
  );
};

export default AppBoxSearch;
